import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AdminRoute = ({ children }) => {
  const { user } = useSelector(state => state.auth);
  const location = useLocation();

  // If user isn't loaded yet, show loading
  if (!user) {
    return <div>Loading...</div>; 
  }

  // If user exists but isn't admin, redirect to login
  if (user.role !== 'admin') {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // User exists and is admin, render children
  return children;
};

export default AdminRoute;